// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconBrandChrome, IconHelp, IconSitemap, IconUserCheck, IconBug, IconChartBar, IconAlertCircle } from '@tabler/icons';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import AddIcon from '@mui/icons-material/Add';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { NavItemType } from 'types';
import useAuth from 'hooks/useAuth';

const Other = () => {
    const { logout, user } = useAuth();

    var roleAdmin: boolean = user?.role?.includes('admin') ? true : false;
    var roleService: boolean = user?.role?.includes('service') ? true : false;

    //var adminCheck: boolean = false;
    console.log('other');

    // constant
    const icons = {
        IconBrandChrome,
        IconHelp,
        IconSitemap,
        IconUserCheck,
        IconChartBar,
        IconAlertCircle
    };

    // ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

    const other: NavItemType = {
        id: 'sample-docs-roadmap',
        icon: IconBrandChrome,
        type: 'group',
        children: [
            // {
            //     id: 'sample-page',
            //     title: <FormattedMessage id="sample-page" />,
            //     type: 'item',
            //     url: '/sample-page',
            //     icon: icons.IconBrandChrome,
            //     breadcrumbs: false
            // },
            {
                // id: 'BDR',
                // title: <FormattedMessage id="BDR" />,
                // type: 'collapse',
                // icon: icons.IconChartBar,
                // children: [
                //     {
                //         id: 'BDR-charts',
                //         title: <FormattedMessage id="Charts" />,
                //         type: 'item',
                //         url: '/sample-page'
                //     }
                // ]
                id: 'BDR',
                title: <FormattedMessage id="BDR" />,
                type: 'collapse',
                icon: icons.IconChartBar,
                children: [
                    {
                        id: 'BDR-Charts',
                        title: <FormattedMessage id="Charts" />,
                        type: 'item',
                        url: '/bdr-chart',
                        breadcrumbs: false
                    },
                    {
                        id: 'BDR-Table',
                        title: <FormattedMessage id="Table" />,
                        type: 'item',
                        url: '/bdr-table',
                        breadcrumbs: false
                    }
                ]
            },
            {
                id: 'Logs',
                title: <FormattedMessage id="Logs" />,
                type: 'collapse',
                icon: icons.IconChartBar,
                children: [
                    {
                        id: 'chart',
                        title: <FormattedMessage id="Charts" />,
                        type: 'item',
                        url: '/logs-charts',
                        breadcrumbs: false
                    },
                    {
                        id: 'table',
                        title: <FormattedMessage id="table" />,
                        type: 'item',
                        url: '/logs-table',
                        breadcrumbs: false
                    }
                ]
            },
            {
                id: 'DTC',
                title: <FormattedMessage id="DTC" />,
                type: 'item',
                url: '/dtc',
                icon: icons.IconAlertCircle,
                breadcrumbs: false
            },
            {
                id: 'users',
                title: <FormattedMessage id="Users" />,
                type: 'item',
                url: '/users',
                icon: icons.IconUserCheck,
                breadcrumbs: false
            },
            // {
            //     id: 'Variables',
            //     title: <FormattedMessage id="Telematics" />,
            //     type: 'item',
            //     url: '/variables',
            //     icon: icons.IconUserCheck,
            //     breadcrumbs: false
            // },
            {
                id: 'Maps',
                title: <FormattedMessage id="Maps" />,
                type: 'item',
                url: '/maps',
                icon: MapOutlinedIcon,
                breadcrumbs: false
            },
            {
                id: 'UploadFile',
                title: <FormattedMessage id="Upload File" />,
                type: 'item',
                url: '/upload-file',
                icon: DriveFolderUploadIcon,
                breadcrumbs: false
            }
        ]
    };
    if (roleAdmin) {
        other.children?.push(
            {
                id: 'ConfigChecker',
                title: <FormattedMessage id="Config Checker" />,
                type: 'item',
                url: '/config-checker',
                icon: DriveFolderUploadIcon,
                breadcrumbs: false
            },
            {
                id: 'DM',
                title: <FormattedMessage id="DM" />,
                type: 'item',
                url: '/dm',
                icon: DriveFolderUploadIcon,
                breadcrumbs: false
            }
        );
    }
    return other;
};

// {
//     id: 'Test',
//     title: <FormattedMessage id="Test" />,
//     type: 'item',
//     url: '/test',
//     breadcrumbs: false
// }
// {
//     id: 'documentation',
//     title: <FormattedMessage id="documentation" />,
//     type: 'item',
//     url: 'https://codedthemes.gitbook.io/berry/',
//     icon: icons.IconHelp,
//     external: true,
//     target: true
// }
// {
//     id: 'roadmap',
//     title: <FormattedMessage id="roadmap" />,
//     type: 'item',
//     url: 'https://codedthemes.gitbook.io/berry/roadmap',
//     icon: icons.IconSitemap,
//     external: true,
//     target: true
// }

export default Other;
